"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M511.8 0C229.1 0-.2 229.2-.2 512s229.2 512 512 512 512-229.2 512-512S794.6 0 511.8 0zm154.9 878.8c-202.6 85.5-436.2-9.3-521.7-211.9s9.3-436.2 211.9-521.7c49-20.7 101.7-31.3 154.9-31.2 219.9 0 398.1 178.3 398 398.2 0 159.9-95.8 304.3-243.1 366.6zM519 489.8V288.1c0-31.3-25.3-56.8-56.5-56.8S406 256.9 406 288.1v227.4c0 18.4 9.2 34 22.8 44.4L587 718.7c22.1 22.1 57.9 22.1 80 .1l.1-.1c22.1-22.3 22.1-58.1 0-80.4L519 489.8z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgClock, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;